import { AttentionBox, Box } from "monday-ui-react-core";
import { Info } from "monday-ui-react-core/icons";

import { GroupedCommandLists } from "@/components/CommandLists";
import { useServiceContext } from "@/services";
import type { Command } from "@/services/runcli";

type Props = {
  onCopy: (command: Command) => void;
};

export function ExamplesPanel({ onCopy }: Props) {
  const {
    cli: { exampleCommands },
  } = useServiceContext();
  return (
    <>
      <Box marginBottom={Box.marginBottoms.MEDIUM}>
        <AttentionBox title="About the examples" icon={Info}>
          Use the examples on this page to help you get started writing your own commands for running automation. Try
          copying one of the examples below and executing it in the "Run" tab, above. Consult the "Documentation" tab
          above for help with special syntax like <code>&#123;&#123;workspaceId&#125;&#125;</code> used below.
        </AttentionBox>
      </Box>
      <GroupedCommandLists commands={exampleCommands} onCopy={onCopy} />
    </>
  );
}
